export default __webpack_public_path__ + "static/media/fai.acf5fde2.png";